import React from "react";

import Setting from "./Setting";
import { apiGet, apiPost } from "../common/API";

class SettingController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'list',
    };
  }

  componentDidMount() {
  }

  backToMenu(e) {
    e.preventDefault();
    this.props.backToMenu();
  }

  render() {
    const {mode} = this.state;
    switch (mode) {
      case '':
        return <Setting {...this.props} handleBack={e => this.backToMenu(e)}/>

    }
    return <Setting {...this.props} handleBack={e => this.backToMenu(e)} />
  }
}

export default SettingController;
